import React from 'react'
import { useIntl } from 'react-intl'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'LuxKit/Typography/BodyText'
import { useOrderTravellers } from 'tripPlanner/hooks/api/order'

type Props = {
  orderId: string
}

function OrderTravellers(props: Props) {
  const intl = useIntl()
  const { data: orderTravellers, status: loadingTravellerStatus } =
    useOrderTravellers(props.orderId)

  return (
    <>
      {loadingTravellerStatus === 'loading' && <LoadingIndicator inline />}
      {loadingTravellerStatus === 'success' &&
        orderTravellers.map((traveller, index) => (
          <div key={traveller.traveller_id}>
            <BodyText variant="medium" weight="bold">
              {intl.formatMessage(
                {
                  id: 'iz/i+tiW1G',
                  defaultMessage: 'Traveller {travellerNumber}',
                  description: 'Label for individual traveller in order details',
                },
                { travellerNumber: index + 1 },
              )}
            </BodyText>
            <BodyText variant="large">{`${traveller.first_name} ${traveller.last_name}`}</BodyText>
            <BodyText variant="medium" colour="neutral-two">
              {traveller.booking_number}
            </BodyText>
          </div>
        ))}
    </>
  )
}

export default OrderTravellers
